"use strict";
/**
 *
 * Select
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("../styles");
const clsx_1 = __importDefault(require("clsx"));
const SvgIcon_1 = require("../SvgIcon");
const SvgExpandMoreIcon_1 = require("../SvgIcon/SvgExpandMoreIcon");
const styles = styles_1.createStyles(({ typography, palette, spacing, shape, shadows }) => ({
    root: {
        position: 'relative',
        textAlign: 'left',
    },
    select: {
        zIndex: 1,
        position: 'relative',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        MozAppearance: 'none',
        WebkitAppearance: 'none',
        outline: 'none',
        userSelect: 'none',
        minWidth: 16,
        width: '100%',
        padding: spacing(0.35, 1),
        background: 'transparent',
        'select&': {
            cursor: 'pointer',
        },
        border: `1px solid ${palette.dark('border')}`,
        borderRadius: shape.borderRadius,
        overflow: 'hidden',
        '&::placeholder': {
            color: palette.textSecondary,
        },
        '&::-ms-expand': {
            display: 'none',
        },
        '&:invalid': {
            color: palette.warning,
            borderColor: palette.warning,
            '& + $icon, & + $label + $icon, & + $label': {
                color: palette.warning,
            },
        },
        '&:hover, &:focus': {
            borderColor: palette.darkest('border'),
            '&:not($disabled)': {
                '& + $icon, & + $label + $icon': {
                    color: palette.textPrimary,
                },
            },
        },
        '&:focus': {
            boxShadow: shadows[5],
            '& + $icon, & + $label + $icon, & + $label': {
                zIndex: 1,
            },
            backgroundColor: palette.surface,
            '&:invalid': {
                backgroundColor: palette.lightest('warning'),
            },
        },
        '&$disabled': {
            cursor: 'not-allowed',
            color: palette.textSecondary,
            borderColor: palette.border,
        },
    },
    selectWithLabel: {
        padding: spacing(2, 1, 0.35, 1),
    },
    selectDense: {
        padding: spacing(0, 0.35),
    },
    selectDenseWithLabel: {
        padding: spacing(1.35, 0.35, 0, 0.35),
    },
    icon: {
        zIndex: 0,
        position: 'absolute',
        display: 'inline-flex',
        top: 0,
        bottom: 0,
        right: 0,
        paddingRight: spacing(1),
        alignItems: 'center',
        color: palette.textSecondary,
        [`& > .${SvgIcon_1.svgIconClassName}`]: {
            color: 'inherit',
        },
    },
    iconDense: {
        paddingRight: spacing(0.35),
    },
    label: Object.assign({ zIndex: 0, alignItems: 'flex-start', top: 0, bottom: 0, left: 0, paddingTop: spacing(0.5), paddingLeft: spacing(1), color: palette.dark('textSecondary'), display: 'inline-flex', lineHeight: 1, position: 'absolute' }, typography.label),
    labelDense: {
        paddingLeft: spacing(0.35),
    },
    disabled: {},
}));
const Select = react_1.default.forwardRef(function Select(props, ref) {
    const { children, classes, className, label, dense, disabled, readOnly } = props, rest = __rest(props, ["children", "classes", "className", "label", "dense", "disabled", "readOnly"]);
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.root, className) },
        readOnly ? (react_1.default.createElement("input", { value: rest.value, readOnly: readOnly, disabled: disabled, className: clsx_1.default(classes.select, label && classes.selectWithLabel, dense && classes.selectDense, dense && label && classes.selectDenseWithLabel, disabled && classes.disabled), ref: ref })) : (react_1.default.createElement("select", Object.assign({}, rest, { disabled: disabled, className: clsx_1.default(classes.select, label && classes.selectWithLabel, dense && classes.selectDense, dense && label && classes.selectDenseWithLabel, disabled && classes.disabled), ref: ref }), children)),
        label && react_1.default.createElement("div", { className: clsx_1.default(classes.label, dense && classes.labelDense) }, label),
        react_1.default.createElement("div", { className: clsx_1.default(classes.icon, dense && classes.iconDense) },
            react_1.default.createElement(SvgExpandMoreIcon_1.SvgExpandMoreIcon, null))));
});
if (process.env.NODE_ENV !== 'production') {
    Select.displayName = 'Select';
}
const StyledSelect = styles_1.withStyles(styles)(Select);
exports.Select = StyledSelect;
